import BaseApiService from './baseApiService';
import {
    CreateApiTokenCommand,
    CreateApiTokenResult,
    BackendTokenVM as ApiTokenVM,
    IsApiTokenExistsCommand
} from '../contracts';

class TokensApiService extends BaseApiService {
    getTokens = () => {
        return this.get<ApiTokenVM[]>('api-tokens');
    };

    addToken = async (data: CreateApiTokenCommand) => {
        return await this.post<CreateApiTokenResult, CreateApiTokenCommand>('api-tokens', data);
    };

    lockToken = async (tokenName: string) => {
        await this.post('api-tokens/lock', { tokenName });
    };

    unlockToken = async (tokenName: string) => {
        await this.post('api-tokens/unlock', { tokenName });
    };

    checkToken = async (tokenName: string) => {
        return await this.post<boolean, IsApiTokenExistsCommand>('api-tokens/exists', { tokenName });
    };
}

export default new TokensApiService();
